export default __webpack_public_path__ + "static/media/referral_banner_image.59d1feab.svg";